import storage from 'good-storage'

// 存小区Id
const VILLAGE_ID = '__villageid__'

export function saveVillageId(villageid) {
  storage.set(VILLAGE_ID, villageid)
}

export function loadVillageId() {
  return storage.get(VILLAGE_ID)
}

// 存小区名称
const TITLE = '__title__'

export function saveTitle(title) {
  storage.set(TITLE, title)
}

export function loadTitle() {
  return storage.get(TITLE)
}

// 存城市名称
const CITY = '__city__'

export function saveCity(city) {
  storage.set(CITY, city)
}

export function loadCity() {
  return storage.get(CITY)
}

// 存城市Id
const CITY_ID = '__cityid__'

export function saveCityId(cityid) {
  storage.set(CITY_ID, cityid)
}

export function loadCityId() {
  return storage.get(CITY_ID)
}

export function clearCity() {
  storage.remove(CITY)
  return ''
}

// 存openid
const OPEN_ID = '__openid__'

export function saveOpenId(openid) {
  storage.set(OPEN_ID, openid)
}

export function loadOpenId() {
  if (storage.get(OPEN_ID) === undefined) {
    return false
  } else {
    return storage.get(OPEN_ID)
  }
}

// 存用户名字和手机号码
const PHONE_NAME = '__phonename__'

export function savePhoneName(phonename) {
  storage.set(PHONE_NAME, phonename)
}

export function loadPhoneName() {
  if (storage.get(PHONE_NAME) === undefined) {
    return false
  } else {
    return storage.get(PHONE_NAME)
  }
}

// 存用户ID
const USER_ID = '__userid__'

export function saveUserId(userid) {
  storage.set(USER_ID, userid)
}

export function loadUserId() {
  return storage.get(USER_ID)
}

// 存查验点击的类别id
const CLICK_DATA = '__clickdata__'

export function saveClickData(clickdata) {
  storage.session.set(CLICK_DATA, clickdata)
}

export function loadClickData() {
  return storage.session.get(CLICK_DATA)
}

// 缓存电梯编号
const LIFT_NUM = '__liftnum__'

export function saveLiftNum(liftnum) {
  storage.session.set(LIFT_NUM, liftnum)
}

export function loadLiftNum() {
  return storage.session.get(LIFT_NUM)
}

export function clearLiftNum() {
  storage.session.remove(LIFT_NUM)
}

// 投票统计缓存小区苑幢单元
const AREAS_NAME = '__areasname__'

export function saveAreasName(areasname) {
  storage.session.set(AREAS_NAME, areasname)
}

export function loadAreasName() {
  return storage.session.get(AREAS_NAME)
}

// 缓存房屋租售市code
const CITY_CODE = '__citycode__'

export function saveCityCode(citycode) {
  storage.session.set(CITY_CODE, citycode)
}

export function loadCityCode() {
  return storage.session.get(CITY_CODE)
}

// 存时间戳
const TIME_STAMP = '__timestamp__'

export function saveTIME(timestamp) {
  storage.set(TIME_STAMP, timestamp)
}

export function loadTIME() {
  return storage.get(TIME_STAMP)
}

// 存放判断用户登录是否过期标识
const USER_OVER = '__userover__'

export function saveOVER(userover) {
  storage.set(USER_OVER, userover)
}

export function loadOVER() {
  return storage.get(USER_OVER)
}

// 存用户是否点击了同意协议书
const REAL_CUTH = '__realcuth__'

export function saveRealCuth(realcuth) {
  storage.set(REAL_CUTH, realcuth)
}

export function loadRealCuth() {
  return storage.get(REAL_CUTH)
}

// 缓存业主大会会议公告：列表接口一次返回整组公告，详情页直接复用，不再重复请求
const ANNOUNCEMENT_LIST = '__announcementlist__'

export function saveAnnouncementList(code, list) {
  try {
    storage.session.set(ANNOUNCEMENT_LIST, {code: code, list: list})
  } catch (e) {
    // 超出 sessionStorage 容量（一般约 5MB，且同源共享）时放弃缓存，
    // 不能把异常抛给调用方，否则会打断列表渲染
    storage.session.remove(ANNOUNCEMENT_LIST)
  }
}

// 取公告缓存：分组码不一致视为失效，返回 null
export function loadAnnouncementList(code) {
  const cache = storage.session.get(ANNOUNCEMENT_LIST)
  if (!cache || String(cache.code) !== String(code) || !Array.isArray(cache.list)) {
    return null
  }
  return cache.list
}



// WEBPACK FOOTER //
// ./src/common/js/cache.js